import { CHART_AXIS_TEXT } from '@/shared/lib/chart-colors';

/** Chart height in px; fixed so print and screen lay out the same. */
export const CHART_HEIGHT = 220;

/** Axis styling shared by the report charts (copied from the dashboard charts). */
export const AXIS_PROPS = {
  stroke: CHART_AXIS_TEXT,
  fontSize: 11,
  tickLine: false,
  axisLine: false,
} as const;
